export default __webpack_public_path__ + "static/media/female-ava.55f19dd6.png";